// extracted by mini-css-extract-plugin
export default {"backButton":"JokerwizInfoPage_backButton__Tqyaj","icon":"JokerwizInfoPage_icon__MnV8d"};